import { format } from 'date-fns';
import { XML_FILE_TYPE, FILE_TYPE_ABBEVIATION_MAP } from '@/finsight/ui/components/filings/constants';
import utcToZonedDate from '@/Framework/DateTime/utcToZonedDate';
import { YEAR_MONTH_DAY_DOT_FORMAT } from '@/Framework/DateTime/dateFormats';

export const isConvertible = (file) => ((file.options && typeof file.options.isConvertible === 'boolean')
  ? file.options.isConvertible
  : true);

export const getFile = (filing) => filing.filingFiles.find(
  (file) => file.type === XML_FILE_TYPE.ASSET_DATA_FILE,
) || {};

export const getRelatedDocument = (filing) => filing.filingFiles.find(
  (file) => file.type === XML_FILE_TYPE.ASSET_RELATED,
) || {};

export const getFileName = (filing, file) => {
  const { acceptanceDatetime: { timezone, dateTime } } = filing;
  const date = format(utcToZonedDate(timezone.timeZone, new Date(dateTime)), YEAR_MONTH_DAY_DOT_FORMAT);
  const issuer = findEntityInData(filing, filing.filerCik);
  const type = getFileType(file);
  return (`${ date }_${ issuer } ${ type }`);// .replace(/\s/g, '-');
};

export const findEntityInData = (filing, cik) => {
  let filers = filing.data['SEC-HEADER'].FILER;
  filers = Array.isArray(filers) ? filers : [filers];
  const file = filers.find((file) => file['COMPANY-DATA'].CIK === cik);
  return file ? file['COMPANY-DATA']['CONFORMED-NAME'] : '';
};

const getFileType = (file) => FILE_TYPE_ABBEVIATION_MAP[file.type] || file.description;
